export default {
  formatValue: (value, formatter, vue) => {
    if (formatter === "k_formatter") {
      return vue.$options.filters.k_formatter(value);
    }
    else if (formatter === "M_formatter") {
      return vue.$options.filters.M_formatter(value);
    } 
    else if (formatter === "KPI_M_k_formatter") {
      return vue.$options.filters.KPI_M_k_formatter(value);
    }
    else if (formatter === "2Digits") {
      return vue.$options.filters.toFriendlyTonnage(value);
    } 
    else if (formatter === "Percentage") {
      return vue.$options.filters.toPercentage(value);
    } else {
      return value;
    }
  }
}
